"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavigationContext = exports.navigationContext = void 0;
var _react = require("react");
var _models = require("../models");
const navigationContext = exports.navigationContext = /*#__PURE__*/(0, _react.createContext)({
  activeProviderId: 0,
  areCustomerCheckoutPrerequisitesLoading: false,
  billingState: 'disabled',
  continueButtonTooltip: undefined,
  customerCheckoutPrerequisites: {},
  isPaymentModelLoading: false,
  isRegistrationVisible: false,
  mutateCustomerCheckoutPrerequisites: async () => undefined,
  navigationButtonsProps: [],
  onRegistrationClose: () => {},
  orderState: _models.OrderState.None,
  paymentModel: undefined,
  registrationId: '',
  selectedStep: _models.ShoppingStep.Basket,
  setActiveProviderId: () => {},
  setBillingState: () => {},
  setCurrentStep: () => {},
  setIsRegistrationVisible: () => {},
  setOrderState: () => {},
  setRegistrationId: () => {},
  setSelectedStep: () => {}
});
const useNavigationContext = () => (0, _react.useContext)(navigationContext);
exports.useNavigationContext = useNavigationContext;